import { mockClient, mockApi } from '@mint-sdk/api-core';

import {
  PLACEMENT_IMPORT_HISTORY_LIST_RESPONSE,
  PLACEMENT_IMPORT_STATUS_RESPONSE,
} from './mocks.js';
import {
  ImportErrorLogQuerySchema,
  ImportPlacementFoldersQuerySchema,
  ImportPlacementFoldersRequestSchema,
  ImportPlacementFoldersResponseSchema,
  ImportPlacementTemplateQuerySchema,
  ValidatePlacementFoldersImportResponseSchema,
  PlacementHistoryListQuerySchema,
  PlacementHistoryListResponseSchema,
  PlacementImportStatusQuerySchema,
  PlacementImportStatusResponseSchema,
} from './schemas.js';

export const getPlacementImportHistoryListQueryOptions = mockClient.query({
  url: 'planning-service/virtuals/placement-folders/import/history/',
  method: 'GET',
  querySchema: PlacementHistoryListQuerySchema,
  responseSchema: PlacementHistoryListResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  mock: () => PLACEMENT_IMPORT_HISTORY_LIST_RESPONSE,
});

export const getImportErrorLogFile = mockApi.declareStream({
  url: 'planning-service/virtuals/placement-folders/import/error-log/' as const,
  method: 'GET',
  querySchema: ImportErrorLogQuerySchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  fullResponse: true,
  mock: async ({ params }) => {
    const blob = new Blob(['hello'], { type: 'text/plain' });
    const fileName =
      typeof params?.id === 'string'
        ? `error_log_${params.id}.txt`
        : 'error_log.txt';

    return {
      data: blob,
      status: 200,
      statusText: 'OK',
      headers: {
        'content-disposition': `attachment; filename="${fileName}"`,
      },
    };
  },
});

export const importPlacementFolders = mockApi.declareMultipart({
  url: 'planning-service/virtuals/placement-folders/import/' as const,
  method: 'POST',
  querySchema: ImportPlacementFoldersQuerySchema,
  requestSchema: ImportPlacementFoldersRequestSchema,
  responseSchema: ImportPlacementFoldersResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  mock: async () => ({ id: `import_${Date.now()}` }),
});

export const validatePlacementFoldersImportFile = mockApi.declareMultipart({
  url: 'planning-service/virtuals/placement-folders/import/validate/' as const,
  method: 'POST',
  requestSchema: ImportPlacementFoldersRequestSchema,
  responseSchema: ValidatePlacementFoldersImportResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  mock: async () => ({ success: true, message: 'File is valid' }),
});

export const getPlacementImportTemplateFile = mockApi.declareStream({
  url: 'planning-service/virtuals/placement-folders/import/template/' as const,
  method: 'GET',
  querySchema: ImportPlacementTemplateQuerySchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  fullResponse: true,
  mock: async () => {
    const blob = new Blob(['hello'], { type: 'text/plain' });

    return {
      data: blob,
      status: 200,
      statusText: 'OK',
      headers: {
        'content-disposition':
          'attachment; filename="placement_import_template.xlsx"',
      },
    };
  },
});

export const getPlacementImportStatusQueryOptions = mockClient.query({
  url: 'planning-service/virtuals/placement-folders/import/',
  method: 'GET',
  querySchema: PlacementImportStatusQuerySchema,
  responseSchema: PlacementImportStatusResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  mock: () => PLACEMENT_IMPORT_STATUS_RESPONSE,
});
